import React from 'react';
import './CustomerFeatures.css';

function CustomerFeatures() {
  // The URL for the background image, taken from the provided HTML.
  const backgroundImageUrl = 'https://sendbird.imgix.net/cms/Oh-Ju-young_2025-06-25-073031_wuww.png';
  
  // The logo URL.
  const logoUrl = 'https://sendbird.imgix.net/cms/Lotte_2025-06-25-091653_jhcz.svg';

  return (
    <div className="customer-features-section">
      <h2 className="features-title">Featured success story</h2>
      
      <div 
        className="featured-story-card" 
        style={{ backgroundImage: `url(${backgroundImageUrl})` }}
      >
        <div className="card-overlay">
          <div className="card-content">
            <img src={logoUrl} alt="Lotte Homeshopping Logo" className="customer-logo" />
            
            <blockquote className="customer-quote">
              “We chose Sendbird and Anthropic Claude for three reasons: accuracy for QA work, supplier access management, and scalability for future AI services.”
            </blockquote>
            
            <div className="quote-author-info">
              <span className="author-name">Oh Ju-young</span>
              <span className="author-title">AI Promotion Team Manager at Lotte Homeshopping</span>
            </div>
            
            <a href="/customers" className="learn-more-link">
              Learn more
              <span className="arrow-icon-wrapper">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerFeatures;